<template>
    <div v-show="visible">
        <el-dialog title="学生作业详情" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="1000px">
            <div style="display: inline-block; height:40px;">
                <el-input v-model="form.name" placeholder="学生姓名"></el-input>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-select style="width: 120px;" v-model="form.readSign" clearable placeholder="请选择">
                    <el-option
                        v-for="item in readSigns"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-select style="width: 120px;" v-model="form.correctTaskSign" clearable placeholder="请选择">
                    <el-option
                        v-for="item in correctTaskSigns"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            <el-button type="success" icon="el-icon-download" @click="exportExcel()">导出Excel</el-button>
            <div style="display: inline-block; height:40px; float: right;">
                <el-button type="primary" @click="downloadFiles()">下载学生作业附件</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="380"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="name" label="学生姓名"  :show-overflow-tooltip="true" width="80" ></el-table-column>
                <el-table-column prop="className" label="班级名称"  width="80"></el-table-column>
                <el-table-column prop="readSign" label="阅读标记" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.readSign == 1">
                            未读
                        </div>
                        <div v-else-if="scope.row.readSign == 2">
                            已读
                        </div>
                        <div v-else-if="scope.row.readSign == 3">
                            提交
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="是否点评" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.correctTaskCount == 0">
                            <span style="color:red">待点评</span>
                        </div>
                        <div v-else-if="scope.row.correctTaskCount > 0">
                            已点评
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="学生提交作业内容" :show-overflow-tooltip="true" width="250"></el-table-column>
                <el-table-column prop="taskSubmitTime" label="学生作业提交时间"  width="150"></el-table-column>
                <el-table-column prop="endSubmitTime" label="截止提交时间"  width="150"></el-table-column>
                <!-- <el-table-column prop="clockinDate" label="打卡日期" :show-overflow-tooltip="true" width="100"></el-table-column>
                <el-table-column prop="giveCount" label="点赞数" :show-overflow-tooltip="true" width="60"></el-table-column>
                <el-table-column prop="commentCount" label="评论数" :show-overflow-tooltip="true" width="60"></el-table-column> -->
                <el-table-column fixed="right" label="操作" width="100" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>

                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)"
                                v-if="scope.row.fileCount > 0 && scope.row.correctTaskCount>0">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleShowData"
                                    icon="el-icon-circle-check">查看附件</el-dropdown-item>
                                <el-dropdown-item command="handleSetCorrect"
                                    icon="el-icon-circle-check">查看老师点评</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)"
                                v-else-if="scope.row.fileCount > 0 ">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleShowData"
                                    icon="el-icon-circle-check">查看附件</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)"
                                 v-else-if="scope.row.correctTaskCount > 0 ">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleSetCorrect"
                                    icon="el-icon-circle-check">查看老师点评</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </el-dialog>
        <!-- 查看附件弹出框 -->
        <div v-if="studentFileVisible">
            <studentFile ref="studentFile"></studentFile>
        </div>
        <!-- 查看老师点评弹出框 -->
        <div v-if="correctTaskVisible">
            <correctTask ref="correctTask"></correctTask>
        </div>
        <!-- 设置任务模板弹出框 -->
        <set-comment-manage v-model="setCommentManageVisible" :taskList="queryForm" :clockinDate="form.clockinDate"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../common/http';
    import studentFile from './StudentFile.vue';
    import correctTask from './CorrectTask.vue';
    import setCommentManage from './components/setCommentManage.vue';

    export default {
        data(){
            return{
                visible:false,
                loading:false,
                loadingText:"",
                studentFileVisible:false,
                correctTaskVisible:false,
                setCommentManageVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                queryForm:{},
                form:{
                    deptId: "",
                    clockinDate: "",
                    taskListId: "",
                    name: "",
                    readSign: "",
                    correctTaskSign: ""
                },
                correctTaskSigns:[{
                    value: 1,
                    label: '待点评'
                },{
                    value: 2,
                    label: '已点评'
                }],
                readSigns:[{
                    value: 1,
                    label: '未读'
                },{
                    value: 2,
                    label: '已读'
                },{
                    value: 3,
                    label: '提交'
                }],
                clockinDates:[],
                data:[],
                id:"",
                title:""
            }
        },
        components: {
            studentFile,correctTask,setCommentManage
        },
        created:function () {
        },
        methods:{
            init(deptId,taskList){
                this.visible=true
                this.form.name = ""
                // 赋值
                this.form.deptId=deptId
                this.queryForm=taskList

                // 打卡日期
                if(this.queryForm.taskType == 2){
                    this.getClockinDates()
                }else{
                    this.form.clockinDate = ""
                    this.getData()
                }
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            dialogClose(done){
                done();
                this.$reload
            },
            downloadFiles(){
                this.loading=true;
                this.loadingText="正在下载中，下载过程时间可能会比较长，请耐心等待";

                let url  = this.taskListDownloadZipFileUrl;
                let param = new URLSearchParams();
                param.append('taskListId', this.queryForm.id);
                // param.append('clockinDate', this.form.clockinDate);
                
                axios({
                    method: "post",
                    url: url,
                    data: param, 
                    responseType: "blob"
                }).then(res => {
                    let data= res.data
                    var blob = new Blob([data])
                    // 创建下载的链接
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    var href = window.URL.createObjectURL(blob);
                    a.href = href;
                    //显示下载文件名 获取后端返回的文件名
                    let filename= res.headers['content-disposition'].split('=')[1]
                    // 文件名中有中文 则对文件名进行转码 decodeURI
                    a.download= decodeURI(filename)   
                    // 利用a标签做下载       
                    document.body.appendChild(a);
                    // 点击下载
                    a.click();
                    // 下载后移除元素
                    document.body.removeChild(a);
                    // 释放掉blob对象
                    window.URL.revokeObjectURL(href);
                    this.loading=false;
                }).catch(error => {
                    console.info('response.error'+error.message);
                    this.loading=false;
                });
            },
            // 导出Excel
            exportExcel(){
                this.loading=true;
                this.loadingText="正在导出中，请稍候...";

                let url  = this.studentaskExportExcelUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('taskType', this.queryForm.taskType);
                param.append('taskListId', this.queryForm.id);
                param.append('clockinDate', this.form.clockinDate);
                param.append('name', this.form.name);
                param.append('readSign', this.form.readSign);
                param.append('correctTaskSign', this.form.correctTaskSign);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '学生作业.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error); 
                    this.loading=false;
                });
            },
            // 获取打卡日期
            getClockinDates(){
                let url  = this.studenTaskGetClockinDatesUrl
                let data = {
                    taskListId:this.queryForm.id,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.clockinDates = res.data
                       if(this.clockinDates.length > 0){
                        this.form.clockinDate = res.data[0]
                        this.getData()
                       }
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            // 获取列表数据
            getData(){
                let url  = this.studentaskListUrl
                let data = {
                    isPage: this.common.isPage,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    deptId: this.form.deptId,
                    taskType: this.queryForm.taskType, 
                    taskListId: this.queryForm.id,
                    clockinDate: this.form.clockinDate,
                    name: this.form.name,
                    readSign: this.form.readSign,
                    correctTaskSign: this.form.correctTaskSign
                };
                // console.log(data);
                this.data =[]
                this.common.total = 0
                this.loading=true;
                this.loadingText="正在加载中...";
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list
                        this.common.total=res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            //删除
            del(data){
                this.form.id = data.id
                this.$commonFn.showConfirm(this.delSuccess)
            },
            delSuccess(){
                let url = this.studentaskRemoveUrl
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1)
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                })
            },
            // 更多操作触发
            handleCommand(command, row) {
                switch (command) {
                    case "handleShowData":
                        this.showData(row)
                        break;
                    case "handleSetCorrect":
                        this.setCorrect(row)
                        break;
                    default:
                        break;
                }
            },
            showData(row){
                this.studentFileVisible=true
                this.$nextTick(() => { 
                    this.$refs['studentFile'].init(this.form.deptId,row.id)
                })
            },
            setCorrect(row){
                this.correctTaskVisible=true
                this.$nextTick(() => { 
                    this.$refs['correctTask'].init(this.form.deptId,row.id)
                })
            },
            // 评语管理
            setCommentManage(){
                this.setCommentManageVisible = true
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/StudentTask.vue